import { Schema } from "@/modules/FormTemplate/models/Schema";
import { FieldUser } from "@/modules/User/models/FieldUser";
import { FullSchema } from "@/shared/models/FullSchema";
import { Component, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";
import { METHODS } from "../../constants/generate-pdf.contants";

Vue.use(Vuetify);
@Component({
  name: "Dropdown"
})
export default class Dropdown extends Vue {
  @Prop({ default: [] }) public infoGroup!: FullSchema;
  @Prop({ default: false }) public error!: boolean;
  @Prop({ default: [] }) public fieldsSelected!: FieldUser[];

  isCollapse = false;

  changeCollapse() {
    this.isCollapse = !this.isCollapse;
  }

  choosenField(property: [string, Schema]) {
    this.$emit(METHODS.CHOOSEN_FIELD, property);
  }
}
